export default __webpack_public_path__ + "static/media/alert.54ad8795.svg";